module.exports = __webpack_public_path__ + "img/63.907b3e81.gif";